import { render } from "./AnalysisOutput.vue?vue&type=template&id=5db0ce3e&scoped=true"
import script from "./AnalysisOutput.vue?vue&type=script&lang=js"
export * from "./AnalysisOutput.vue?vue&type=script&lang=js"

import "./AnalysisOutput.vue?vue&type=style&index=0&id=5db0ce3e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/toki-pona-translator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db0ce3e"]])

export default __exports__